document.addEventListener('DOMContentLoaded', function () {
  const searchWrapper = document.querySelector('.header__search-wrapper');
  const dropdown = document.getElementById('site-search-dropdown');
  const headerWrapper = document.querySelector('[data-header-wrapper]');

  if (!dropdown || !searchWrapper) return;

  const input = dropdown.querySelector('.js-search-input');
  const resultsNode = dropdown.querySelector('.js-search-results');
  const suggestionsNode = dropdown.querySelector('.js-search-suggestions');

  // Read settings from data attributes
  const fallbackMode = dropdown.dataset.fallbackMode || 'collection';
  const fallbackCollection = dropdown.dataset.fallbackCollection || 'bestsellers';
  const resultsLimit = parseInt(dropdown.dataset.resultsLimit || '3', 10);

  let hideTimeout = null;
  const HIDE_DELAY = 150;

  // Hover behavior with delay (matching Shop dropdown pattern)
  // Manual visibility control to avoid CSS hover conflicts
  if (window.innerWidth >= 990) {
    // Wrapper mouseenter: show dropdown
    searchWrapper.addEventListener('mouseenter', function () {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }

      // Manually show dropdown
      dropdown.style.visibility = 'visible';
      dropdown.style.opacity = '1';
      dropdown.style.pointerEvents = 'auto';

      // Add class for white background on homepage
      if (headerWrapper) {
        headerWrapper.classList.add('header--search-open');
      }

      // Focus input and load results
      if (input) input.focus();
      fetchFallbackAndRender('');
    });

    // Wrapper mouseleave: delayed hide
    searchWrapper.addEventListener('mouseleave', function () {
      hideTimeout = setTimeout(function () {
        // Manually hide dropdown
        dropdown.style.visibility = 'hidden';
        dropdown.style.opacity = '0';
        dropdown.style.pointerEvents = 'none';

        if (headerWrapper) {
          headerWrapper.classList.remove('header--search-open');
        }
        if (input) input.blur();
      }, HIDE_DELAY);
    });

    // Dropdown mouseenter: cancel hide timeout
    dropdown.addEventListener('mouseenter', function () {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
    });

    // Dropdown mouseleave: delayed hide
    dropdown.addEventListener('mouseleave', function () {
      hideTimeout = setTimeout(function () {
        // Manually hide dropdown
        dropdown.style.visibility = 'hidden';
        dropdown.style.opacity = '0';
        dropdown.style.pointerEvents = 'none';

        if (headerWrapper) {
          headerWrapper.classList.remove('header--search-open');
        }
        if (input) input.blur();
      }, HIDE_DELAY);
    });
  }

  // Debounced input handler
  let debounceTimer = null;
  if (input) {
    input.addEventListener('input', function (e) {
      const q = e.target.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (q.length === 0) {
          fetchFallbackAndRender('');
        } else {
          fetchPredictiveAndRender(q);
        }
      }, 250);
    });
  }

  function fetchPredictiveAndRender(query) {
    const limit = Math.max(1, resultsLimit);
    // Use higher limit for suggestions (10 instead of 3)
    const suggestionLimit = 10;
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${suggestionLimit}`;

    fetch(url)
      .then(res => res.json())
      .then(data => {
        const items = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderSuggestions(items);

        // Fetch full product JSON for accurate data (limit to resultsLimit for display)
        const handles = items.map(i => i.handle).filter(Boolean).slice(0, limit);
        if (handles.length === 0) {
          resultsNode.innerHTML = '<div class="search-results-header">Results</div><p class="muted">No matches</p>';
          return;
        }
        Promise.all(handles.map(h => fetch(`/products/${encodeURIComponent(h)}.js`).then(r => r.ok ? r.json() : null).catch(() => null)))
          .then(products => {
            const valid = products.filter(Boolean).slice(0, limit);
            if (valid.length) renderResultsFromProducts(valid);
            else resultsNode.innerHTML = '<div class="search-results-header">Results</div><p class="muted">No matches</p>';
          });
      })
      .catch(() => {
        fetchFallbackAndRender(query);
      });
  }

  function renderSuggestions(items) {
    if (!suggestionsNode) return;
    if (!items || items.length === 0) {
      suggestionsNode.innerHTML = '';
      suggestionsNode.setAttribute('aria-hidden', 'true');
      return;
    }

    let html = '<div class="search-suggestions-label">SUGGESTIONS</div>';
    html += '<div class="search-suggestions-list">';

    // Show all suggestions (not limited)
    html += items.map(item => {
      const q = item.term || item.title || item.handle || item.product_title || '';
      return `<a href="#" class="search-suggestion-link" data-term="${escapeHtml(q)}">${escapeHtml(q)}</a>`;
    }).join('');

    html += '</div>';

    suggestionsNode.innerHTML = html;
    suggestionsNode.setAttribute('aria-hidden', 'false');

    // Attach click handlers
    suggestionsNode.querySelectorAll('.search-suggestion-link').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const term = this.dataset.term || '';
        if (input) {
          input.value = term;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  }

  function fetchFallbackAndRender(query) {
    const limit = Math.max(1, resultsLimit);
    let isFallbackDollars = true;
    if (fallbackMode === 'collection') {
      const url = `/collections/${encodeURIComponent(fallbackCollection)}/products.json?limit=${limit}`;
      fetch(url)
        .then(res => res.json())
        .then(data => {
          const products = data.products || [];
          renderResultsFromProducts(products, isFallbackDollars);
        })
        .catch(() => {
          resultsNode.innerHTML = '<div class="search-results-header">Results</div><p class="muted">No products</p>';
        });
    } else {
      const url = `/products.json?limit=${limit}`;
      fetch(url)
        .then(res => res.json())
        .then(data => {
          const products = data.products || [];
          renderResultsFromProducts(products, isFallbackDollars);
        })
        .catch(() => {
          resultsNode.innerHTML = '<div class="search-results-header">Results</div><p class="muted">No products</p>';
        });
    }
  }

  function renderResultsFromProducts(products, isFallbackDollars = false) {
    if (!products || products.length === 0) {
      resultsNode.innerHTML = '<div class="search-results-header">Results</div><p class="muted">No products</p>';
      return;
    }

    // Build DOM nodes safely to avoid XSS; use DocumentFragment for performance
    resultsNode.innerHTML = '';
    const header = document.createElement('div');
    header.className = 'search-results-header';
    header.textContent = 'Results';
    resultsNode.appendChild(header);

    const grid = document.createElement('div');
    grid.className = 'search-results-grid';

    const frag = document.createDocumentFragment();
    products.slice(0, Math.max(1, resultsLimit)).forEach(prod => {
      const title = prod.title;
      const url = prod.handle ? `/products/${prod.handle}` : (prod.url || '#');
      const image = (prod.images && prod.images[0]) ? prod.images[0] : (prod.featured_image || '');
      
      // Build price string similar to dukes-featured-products.liquid
      // Handle compare_at_price, price_varies (price range), and regular price
      let priceHtml = '';
      const variants = prod.variants || [];
      const firstVariant = variants[0] || {};
      // If fallback, prices are already in dollars, else in cents
      const price = isFallbackDollars ? firstVariant.price * 100 : firstVariant.price;
      const compareAtPrice = isFallbackDollars ? firstVariant.compare_at_price * 100 : firstVariant.compare_at_price;
      // Check if price varies across variants
      const prices = variants.map(v => isFallbackDollars ? v.price * 100 : v.price).filter(p => p != null);
      const priceMin = prices.length > 0 ? Math.min(...prices) : null;
      const priceMax = prices.length > 0 ? Math.max(...prices) : null;
      const priceVaries = priceMin !== null && priceMax !== null && priceMin !== priceMax;
      if (compareAtPrice && compareAtPrice > price) {
        // Sale price
        priceHtml = `<span class="sale-price">${moneyFormat(price)}</span> <s class="compare-price">${moneyFormat(compareAtPrice)}</s>`;
      } else if (priceVaries) {
        // Price range
        priceHtml = `<span class="price-range">${moneyFormat(priceMin)} – ${moneyFormat(priceMax)}</span>`;
      } else if (price != null) {
        // Regular price
        priceHtml = moneyFormat(price);
      }
      
      const node = buildProductCardElement({ title, url, image, priceHtml });
      frag.appendChild(node);
    });

    grid.appendChild(frag);
    resultsNode.appendChild(grid);
  }

  /**
   * Formats a given amount into the active currency format.
   * With Shopify Markets enabled, /products/:handle.js returns prices ALREADY CONVERTED
   * to the customer's selected currency. Do NOT apply the rate again.
   * @param {string|number} amount - The amount to format (in cents, already in customer's currency).
   * @returns {string} - The formatted currency string.
   */
  function moneyFormat(amount) {
    if (amount === null || amount === undefined || amount === '') return '';
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'AUD';

    // Get currency_code_enabled from the dropdown data attribute
    let showCode = true;
    const dropdown = document.getElementById('site-search-dropdown');
    if (dropdown && dropdown.dataset.currencyCodeEnabled !== undefined) {
      // Liquid outputs 'true' or 'false' as string
      showCode = String(dropdown.dataset.currencyCodeEnabled) === 'true';
    }

    // Parse the amount - Shopify returns prices in cents (already in customer's currency with Markets)
    let cents = 0;
    if (typeof amount === 'string') {
      // Remove any currency symbols/formatting and parse as number
      cents = parseFloat(amount.replace(/[^0-9.-]+/g, '')) || 0;
    } else {
      cents = Number(amount) || 0;
    }

    // Convert cents to dollars - NO rate conversion needed (Markets already converts)
    const dollars = cents / 100;

    // Format with proper currency symbol and locale, respecting currency_code_enabled
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      currencyDisplay: showCode ? 'code' : 'symbol'
    }).format(dollars);
  }

  /**
   * Sanitizes a URL to prevent XSS vulnerabilities.
   * @param {string} u - The URL to sanitize.
   * @returns {string} - The sanitized URL.
   */
  function sanitizeUrl(u) {
    try {
      if (!u) return '#';
      const s = String(u).trim();
      if (s.indexOf('/') === 0) return s; // relative path
      if (/^(https?:)?\/\//i.test(s)) return s; // absolute or protocol-relative
      return '#';
    } catch (e) {
      return '#';
    }
  }

  function buildProductCardElement({ title, url, image, priceHtml }) {
    const link = document.createElement('a');
    link.className = 'search-product-card';
    link.href = sanitizeUrl(url || '#');

    const imgWrap = document.createElement('div');
    imgWrap.className = 'dukes-featured__image-wrapper';

    const imageUrl = typeof image === 'string' ? image : (image && image.src ? image.src : '');
    if (imageUrl) {
      const img = document.createElement('img');
      img.className = 'dukes-featured__image';
      img.loading = 'lazy';
      img.src = sanitizeUrl(imageUrl);
      img.alt = escapeHtml(title);
      imgWrap.appendChild(img);
    } else {
      const ph = document.createElement('div');
      ph.className = 'dukes-featured__placeholder';
      ph.textContent = (title && title.charAt ? title.charAt(0) : '?') || '?';
      imgWrap.appendChild(ph);
    }

    const info = document.createElement('div');
    info.className = 'dukes-featured__info';

    const h3 = document.createElement('h3');
    h3.className = 'dukes-featured__title';
    h3.textContent = title || '';

    const p = document.createElement('p');
    p.className = 'dukes-featured__price';
    // Use innerHTML to support sale/compare price markup
    p.innerHTML = priceHtml || '';

    info.appendChild(h3);
    info.appendChild(p);

    link.appendChild(imgWrap);
    link.appendChild(info);

    return link;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/[&<>"']/g, function (s) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s]);
    });
  }
});
